import { Skeleton } from '@repo/ui/components/skeleton';
import { cn } from '@repo/ui/lib/cn';
import * as React from 'react';

interface LoadingStateProps {
  message?: string;
  className?: string;
}

const LoadingState = React.forwardRef<HTMLDivElement, LoadingStateProps>(
  ({ message, className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col items-center justify-center py-12',
          className,
        )}
      >
        <div className="flex flex-col items-center gap-4">
          <div className="flex gap-2">
            <Skeleton className="h-3 w-3 rounded-full" />
            <Skeleton className="h-3 w-3 rounded-full" />
            <Skeleton className="h-3 w-3 rounded-full" />
          </div>
          {message && (
            <p className="text-muted-foreground text-sm">{message}</p>
          )}
        </div>
      </div>
    );
  },
);
LoadingState.displayName = 'LoadingState';

export { LoadingState };
